<script>

    import { replace } from 'svelte-spa-router'
    import { userStore, adminStore } from '../stores'

    import ModalsUsers from './modals.users.svelte'
    import TitleHero from '../$components/title.hero.svelte'
    import Button from '../$components/button.svelte'
    import Tabs from '../$components/tabs.svelte'

    import UserComponent from './component.user.svelte'
    import UserAdviserComponent from './component.adviser.svelte'
    import UserOwnerComponent from './component.owner.svelte'
    import UserAdviserDisabled from './component.adviser.disabled.svelte'

    import WalletComponent from '../wallets/component.wallet.svelte'
    import CreditsComponent from '../credits/component.credits.svelte'
    import ChargesComponent from '../charges/component.charges.svelte'
    import FixedpricesComponent from '../fixedprices/component.fixedprices.svelte'
    import PrepaidsComponent from '../prepaids/component.prepaids.user.svelte'
    import AccountsComponent from '../accounts/component.accounts.svelte'
    import NotificationsComponent from '../notifications/component.notifications.svelte'
    import UserProvidersComponent from './component.providers.svelte'
    import ShipmentsReportComponent from '../shipments/component.shipments.report.svelte'
    import InvoicesView from '../facturama/view.invoice.svelte'

    let tabMain = 'user'

    if(!$userStore)
        replace('#/users')

    const tabMainOptions = [
        {key: 'user', name:'Información', icon: 'user'},
        $adminStore.role === 'admin'? {key: 'adviser', name:'Asesor', icon: 'user-tie'} : null,
        {key: 'wallet', name: 'Cartera', icon: 'wallet'},
        {key: 'credits', name: 'Créditos', icon: 'file-invoice-dollar'},
        {key: 'charges', name: 'Cargos', icon: 'file-invoice-dollar'},
        {key: 'accounts', name:'Cuentas', icon: 'file-invoice-dollar'},
        {key: 'prepaids', name:'Prepagos', icon: 'shopping-cart'},
        {key: 'pricing', name:'Precios fijos', icon: 'money-check-alt'},
        {key: 'providers', name:'Proveedores', icon: 'truck'},
        {key: 'notifications', name:'Notificaciones', icon: 'bell'},
        {key: 'reports', name:'Reportes', icon: 'file-csv'},
    ].filter(item => !!item)

</script>

<ModalsUsers />

{#if $userStore}

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={() => userStore.set(null)} text="Volver" color="primary" icon="arrow-left" />
    </div>

    <TitleHero title={ $userStore.name } subtitle={ $userStore.email } />

    <nav class="user-section-tabs mb-4" aria-label="Navegación de usuario">
        <Tabs bind:selected={tabMain} options={tabMainOptions} size="boxed" />
    </nav>

    <div>
        {#if tabMain === 'user'}
            <UserComponent />

            {#if $userStore.role == 'adviser'}
                <UserAdviserDisabled />
            {/if}
        {/if}

        {#if tabMain === 'adviser'}
            <UserOwnerComponent />
            <br>
            <UserAdviserComponent />
        {/if}

        {#if tabMain === 'wallet'}
            <WalletComponent />
        {/if}

        {#if tabMain === 'credits'}
            <CreditsComponent />
        {/if}

        {#if tabMain === 'charges'}
            <ChargesComponent />
        {/if}

        {#if tabMain === 'pricing'}
            <FixedpricesComponent />
        {/if}

        {#if tabMain === 'accounts'}
            <AccountsComponent />
        {/if}

        {#if tabMain === 'prepaids'}
            <PrepaidsComponent />
        {/if}

        {#if tabMain === 'notifications'}
            <NotificationsComponent />
        {/if}

        {#if tabMain === 'invoices'}
            <InvoicesView />
        {/if}

        {#if tabMain === 'reports'}
            <ShipmentsReportComponent />
        {/if}

        {#if tabMain === 'providers'}
            <UserProvidersComponent />
        {/if}
    </div>
{/if}

<style>
    .user-section-tabs {
        overflow-x: auto;
    }

    .user-section-tabs :global(.tabs) {
        flex-wrap: nowrap;
    }

    .user-section-tabs :global(.tabs ul) {
        flex-wrap: nowrap;
        border-bottom-color: transparent;
    }
</style>
